import { message } from "antd";
import { assistant, session_id } from "../../../utils/axios/assistant";
import { backoffice } from "../../../utils/axios/backoffice";

export async function getRequiresAttentionList() {
  try {
    const { data } = await assistant.get(
      `/requires-attention-list?session_id${session_id}`
    );

    if (data.ok) {
      return data.data;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error.message);
    return [];
  }
}

export async function getConversationList(filters, page) {
  try {
    const { data } = await backoffice.post(
      `/conversations-list?session_id=${session_id}&page=${page}`,
      filters
    );

    if (data.ok) {
      return data;
    } else {
      console.log(data.error);
      return {
        ok: false,
        last_timestamp: "",
        conversationIds: [],
        data: [],
      };
    }
  } catch (error) {
    console.log(error.message);
    return {
      ok: false,
      last_timestamp: "",
      conversationIds: [],
      data: [],
    };
  }
}

export async function getNewConversationList(filters) {
  try {
    const { data } = await backoffice.post(
      `/new-conversations?session_id=${session_id}`,
      filters
    );

    if (data.ok) {
      return data;
    } else {
      console.log(data.error);
      message.error(
        "Ocurrió un error inesperado al intentar obtener la lista de conversaciones"
      );
      return {
        changes: false,
        conversationIds: [],
        last_timestamp: "",
        data: [],
      };
    }
  } catch (error) {
    console.log(error.message);
    message.error(
      "Ocurrió un error inesperado al intentar obtener la lista de conversaciones"
    );
    return {
      changes: false,
      conversationIds: [],
      last_timestamp: "",
      data: [],
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/NaduChat/utils/conversations.js